import "../styles/WorkThatWorks.css";
import {Badge} from "./Badge";
import * as React from "react";
import {Config} from "../Config";
import {Button, ButtonIcon, ButtonType} from "./Button";
import {Carousel, CarouselDirection} from "./Carousel";

export const WorkThatWorks = (props) => {

    const carousel1 = Config.CarouselProjects.slice(0, Config.CarouselProjects.length / 2).map((project) => {
        return <img src={project.url} alt={project.altText} />
    });
    const carousel2 = Config.CarouselProjects.slice(Config.CarouselProjects.length / 2, Config.CarouselProjects.length).map((project) => {
        return <img src={project.url} alt={project.altText} />
    }).reverse();

    return <div className={"work-that-works section"}>
        <div className="our-works card animate-from-bottom" id={Config.PageSections.WorkThatWorks}>
            <div className={"content-part"}>
                <Badge className={"animate-from-bottom"}>Work that works</Badge>
                <h2 className={"animate-from-bottom delay-1"}>
                    See What We’ve Been Building
                </h2>
                <p className="subtitle animate-from-bottom delay-2">
                    Get a closer look at real projects we’ve crafted. Yours could be next.
                </p>
                <div className={"buttons animate-from-bottom delay-3"}>
                    <Button classes={["btn-md"]} type={ButtonType.Link} onClick={Config.ShowcaseLink} icon={ButtonIcon.Figma} openInNewTab={true}>See Our Work</Button>
                    <Button classes={["btn-light", "btn-md"]} type={ButtonType.Link} onClick={"#" + Config.PageSections.Booking} icon={ButtonIcon.Calendar}>Book a Call With Us</Button>
                </div>
            </div>
            <div className={"carousel-part animate-from-bottom delay-4"}>
                <Carousel items={carousel1} direction={CarouselDirection.Vertical} />
                <Carousel items={carousel2} direction={CarouselDirection.VerticalReverse} />
            </div>
        </div>
    </div>;
}
